import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// 浏览器先找路由  v8再执行js代码
// 所以需要在此判断
const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|webOS|Windows Phone|SymbianOS|IEMobile|Opera Mini/i.test(navigator.userAgent);
sessionStorage.setItem('isMobile', isMobile ? 'isMobile' : '');
// 暂时不需要进行手机自适应

import VueRouter from 'vue-router';
Vue.use(VueRouter);
const RouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return RouterPush.call(this, to).catch(err => err);
};
const RouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
  return RouterReplace.call(this, to).catch(err => err);
};

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savePosition) {
    // return 期望滚动到哪个的位置
    return {
      y: 0
    };
  },
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: () => {
        if (!isMobile) {
          return import('../pc/home/index.vue');
        } else {
          return import('../mobile/home/mobile-home.vue');
        }
      }
    },
    {
      path: '/mercury-project',
      name: 'mercury-project',
      redirect: '/mercury-project'
    },
    {
      path: '/mercury-project/about',
      name: 'projectAbout',
      component: () => {
        if (!isMobile) {
          return import('../pc/mercury-about/index.vue'); // 统一根据isMobile来判断
        } else {
          return import('../mobile/plan/mercury-about.vue');
        }
      }
    },
    {
      path: '/mercury-project/service',
      name: 'projectService',
      component: () => {
        if (!isMobile) {
          return import('../pc/mercury-service/index.vue'); // 统一根据isMobile来判断
        } else {
          return import('../mobile/plan/develop-service.vue');
        }
      }
    },
    {
      path: '/bioengineering-technology',
      name: 'BioengineeringTechnology',
      component: () => {
        if (!isMobile) {
          return import('../pc/bioengineering-technology/index.vue');
        } else {
          return import('../mobile/bioengineering/biology.vue');
        }
      }
    },
    {
      path: '/molecular-diagnosis',
      name: 'MolecularDiagnosis',
      component: () => {
        if (!isMobile) {
          return import('../pc/bioengineering-technology/index.vue');
        } else {
          return import('../mobile/bioengineering/biology.vue');
        }
      }
    },
    {
      path: '/case',
      name: 'case',
      component: () => import('../pc/case/index.vue')
    },
    {
      path: '/about',
      name: 'about', // todo: 统一改变为点击下拉进行页面跳转
      redirect: '/about'
    },
    {
      path: '/about/about-introduce',
      name: 'introduce',
      component: () => {
        if (!isMobile) {
          return import('../pc/about-introduce/index.vue');
        } else {
          return import('../mobile/about/introduce.vue');
        }
      }
    },
    {
      path: '/about/about-join',
      name: 'join',
      component: () => {
        if (!isMobile) {
          return import('../pc/about-join/index.vue');
        } else {
          return import('../mobile/about/join.vue');
        }
      }
    },
    {
      path: '/about/about-connect',
      name: 'connect',
      component: () => {
        if (!isMobile) {
          return import('../pc/about-connect/index.vue');
        } else {
          return import('../mobile/about/connect.vue');
        }
      }
    },
    {
      path: '/about/about-report',
      name: 'report',
      component: () => {
        if (!isMobile) {
          return import('../pc/about-report/report.vue');
        } else {
          return import('../mobile/about/report.vue');
        }
      }
    },
    {
      path: '/about/contact',
      name: 'contact',
      component: () => {
        if (isMobile) {
          return import('../mobile/fill_info/fill.vue');
        }
      }
    },
    {
      path: '/about/carousel',
      name: 'carousel',
      component: () => {
        if (isMobile) {
          return import('../mobile/carousel/carousel.vue');
        }
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js